import shoe from '../assets/img/shoe.jpg'
import apparel from '../assets/img/apparel.jpg'
import hat from '../assets/img/hat.jpg'
import trouser from '../assets/img/trouser.jpg'

export const EQUINOSAS = [
    {
        id: 0,
        name: "Hoka Clifton 8",
        image: shoe,
        elevation: 1233,
        featured: false,
        description: "Hoka Clifton 8 $139.95 or 4 interest-free payments of $34.99 with afterpay"
    },
    {
        id: 1,
        name:"DC",
        image: apparel,
        elevation: 877,
        featured: false,
        description: "DC X Star Wars Apparel Collection $31.95 or 4 interest-free payments of $7.99 with"
    },
    {
        id: 2,
        name:"Billabong",
        image: hat,
        elevation: 2901,
        featured: false,
        description: "Billabong Stacked Trucker Hat $27.95 or 4 interest-free payments of $6.99 with afterpay"
    },
    {
        id: 3,
        name:"linksoul",
        image: trouser,
        elevation: 42,
        featured: true,
        description: "Brouderwalker Chino Trousers $89.99 or 4 interest-free payments of $22.50 with afterpay"
    }
];